import {
  collection,
  doc,
  addDoc,
  setDoc,
  onSnapshot,
  query,
  orderBy,
  limit,
  serverTimestamp,
  getDocs,
  updateDoc,
  increment,
} from 'firebase/firestore';
import { db } from '../../utils/firebase';

export const DEFAULT_TOPICS = [
  { id: 'ogolny', title: 'Ogólny', description: 'Rozmowy na dowolny temat' },
  { id: 'lotto', title: 'Lotto', description: 'Dyskusje o Lotto' },
  { id: 'mini-lotto', title: 'Mini Lotto', description: 'Mini Lotto i typowania' },
  { id: 'eurojackpot', title: 'Eurojackpot', description: 'Eurojackpot i wyniki' },
  { id: 'multi-multi', title: 'Multi Multi', description: 'Multi Multi i strategie' },
  { id: 'strategie', title: 'Strategie', description: 'Systemy i metody typowania' },
  { id: 'wyniki', title: 'Wyniki', description: 'Ostatnie losowania i analizy' },
];

let defaultsSeeded = false;

export async function ensureDefaultTopics() {
  if (defaultsSeeded) return;
  defaultsSeeded = true;

  const topicsRef = collection(db, 'chat-topics');
  const snapshot = await getDocs(topicsRef);

  if (snapshot.empty) {
    await Promise.all(
      DEFAULT_TOPICS.map((topic) =>
        setDoc(doc(db, 'chat-topics', topic.id), {
          title: topic.title,
          description: topic.description,
          isDefault: true,
          createdAt: serverTimestamp(),
          messageCount: 0,
        })
      )
    );
  }
}

export function subscribeTopics(callback) {
  const q = query(collection(db, 'chat-topics'), orderBy('createdAt', 'asc'));
  return onSnapshot(
    q,
    (snapshot) => {
      const topics = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      callback(topics);
    },
    (error) => {
      console.error('Błąd subskrypcji tematów:', error);
      callback(DEFAULT_TOPICS.map((t) => ({ ...t, isDefault: true, messageCount: 0 })));
    }
  );
}

export function subscribeMessages(topicId, callback) {
  const q = query(
    collection(db, 'chat-topics', topicId, 'messages'),
    orderBy('createdAt', 'asc'),
    limit(200)
  );
  return onSnapshot(
    q,
    (snapshot) => {
      const messages = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      callback(messages);
    },
    (error) => {
      console.error('Błąd subskrypcji wiadomości:', error);
      callback([]);
    }
  );
}

export async function createTopic({ title, description, nickname, visitorId }) {
  const docRef = await addDoc(collection(db, 'chat-topics'), {
    title: title.trim(),
    description: (description || '').trim(),
    isDefault: false,
    createdBy: visitorId,
    createdByNickname: nickname,
    createdAt: serverTimestamp(),
    messageCount: 0,
  });
  return docRef.id;
}

export async function sendMessage({ topicId, text, nickname, visitorId }) {
  await addDoc(collection(db, 'chat-topics', topicId, 'messages'), {
    text: text.trim(),
    nickname,
    visitorId,
    createdAt: serverTimestamp(),
  });

  try {
    await updateDoc(doc(db, 'chat-topics', topicId), {
      messageCount: increment(1),
      lastMessageAt: serverTimestamp(),
    });
  } catch {
    // topic doc may not exist for legacy defaults
  }
}
